export enum EnvLevel {
  DEV = 'dev',
  PREPROD = 'preprod',
  PROD = 'prod',
  TESTING = 'testing',
}

export const getEnvLevel = () =>
  process.env.GATSBY_ENV_LEVEL as EnvLevel | undefined;
